import ConferenceController from "../audioConference/ConferenceController"
import {AudioConferenceController} from "./index";

const hark = require('hark');
const moment = require('moment');

export default class AgoraWebRTCController extends ConferenceController {
    constructor() {
        {
            super();
        }

        {
            this.client = undefined;
            this.microphoneTrack = undefined;
        }

        {
            this.volumeLevel = 200;
            this.mediaType = {
                AUDIO: 'audio'
            };
            this.remoteUsers = {};
        }

        {
            this.setLogLevel();
        }
    }

    // interface declaration

    async initializeConference(initialize) {
        try {
            wv.effectController.audioConferenceEnabled = initialize;
            checkBoxSyncVR('webRTCInit', initialize);

            updateParticipantConferenceInfo(wv.registeredID.toString(), initialize);

            if (initialize) {
                await this.joinClient(wv.registeredID.toString());
            } else {
                await this.leaveClient();
                AudioConferenceController.playNotification(AudioConferenceController.NotificationTypeEnum.LEFT);
            }

            this.updateConferenceStatus(initialize);
        } catch (error) {
            this.handleError(error);
        }
    }

    muteAudio(value) {
        wv.effectController.audioEnabled = value;
        checkBoxSyncVR('muteAudio', value);

        for (let userId in this.remoteUsers) {
            this.muteThisUserAudio(userId, value);
        }
    }

    muteMicrophone(value) {
        wv.effectController.microphoneDisabled = value;
        checkBoxSyncVR('muteMic', value);
        menuViewToolbarController.updateAudioConferenceMuteMicrophoneIcon('muteMic', value ? 'Unmute' : 'Mute', value);

        this.updateMuteStatus(value);

        wv.sendTextMessage(text_updateMuteStatus, wv.registeredID, value ? '1' : '0');
    }

    endConnectionOfThisUser(userId) {
        this.removeUserFromCanvas(userId)
    }


    // server message handlers

    handleClientFailure(userId) {
        delete this.remoteUsers[userId];
        this.removeUserFromCanvas(userId);
    }

    async stopConference() {
        await this.leaveClient();

        this.updateConferenceStatus(false);

        this.updateConferenceMenuStatus(false);

        for (let key in wv.effectController.Participants) {
            if (wv.effectController.Participants.hasOwnProperty(key)) {
                updateParticipantConferenceInfo(key, false);
            }
        }
        AudioConferenceController.playNotification(AudioConferenceController.NotificationTypeEnum.LEFT);
    }

    async handleEndCall(userId) {
        if (userId === wv.registeredID) {
            await this.leaveClient();
            this.updateConferenceStatus(false);
            this.updateConferenceMenuStatus(false);
        }

        this.removeUserFromCanvas(userId);
        updateParticipantConferenceInfo(userId, false);
        if (wv.effectController.audioConferenceEnabled) {
            AudioConferenceController.playNotification(AudioConferenceController.NotificationTypeEnum.LEFT);
        }
    }

    // private functions

    /*

    setLogLevel()

    0: DEBUG. Output all API logs.
    1: INFO. Output logs of the INFO, WARNING and ERROR level.
    2: WARNING. Output logs of the WARNING and ERROR level.
    3: ERROR. Output logs of the ERROR level.
    4: NONE. Do not output any log.

    */
    setLogLevel() {
        AgoraRTC.setLogLevel(3);
    }

    createClient() {
        this.client = AgoraRTC.createClient({
            mode: "rtc",
            codec: "vp8"
        });
    }

    handleError(error) {
        console.log("AgoraRTC Error: ", error);
    }

    async joinClient(userId) {
        try {
            const appId = await AudioService.getAgoraConferenceAppId();
            const channelName = getMeetingIdFromURL();
            const token = await AudioService.getAgoraRtcToken({
                userId: userId,
                expirationTime: this.getMeetingExpirationTimeInSeconds(),
                channelName: channelName
            });

            if (!this.client) {
                this.createClient();
            }

            this.client.on('user-published', this.handleUserPublished.bind(this));
            this.client.on('user-unpublished', this.handleUserUnpublished.bind(this));
            this.client.on('token-privilege-will-expire', this.handleUserTokenExpiration.bind(this));

            await this.client.join(appId, channelName, token, userId);

            this.microphoneTrack = await AgoraRTC.createMicrophoneAudioTrack();

            this.microphoneTrack.setVolume(this.volumeLevel);
            await this.client.publish(this.microphoneTrack);

            if (wv.effectController.Participants[userId].isMute) {
                updateParticipantConferenceInfo(userId, true);
                this.updateMuteStatus(true);
            }

        } catch (error) {
            this.handleError(error);
        }
    }

    async handleUserTokenExpiration() { // function will be called 30 sec before token expiration
        try {
            const token = await AudioService.getAgoraRtcToken({
                userId: this.client.uid,
                expirationTime: this.getMeetingExpirationTimeInSeconds(),
                channelName: getMeetingIdFromURL()
            });

            await this.client.renewToken(token); // renew the new token for this user in agora sdk

        } catch (error) {
            this.handleError(error);
        }
    }

    getMeetingExpirationTimeInSeconds() {
        const meetingData = wv.effectController.meetingInfo.data;
        const duration = moment.duration(moment(meetingData.extendedEndMeetingTime ? meetingData.extendedEndMeetingTime : moment().add(24, 'hours')).diff(moment()));
        return parseInt(duration.asSeconds());
    }

    async leaveClient() {
        try {
            if (this.client) {
                await this.client.unpublish();
                await this.client.leave();
            }

            this.remoteUsers = {};

            this.updateConferenceMenuStatus(false);

            this.removeUserFromCanvas(wv.registeredID.toString());
        } catch (error) {
            this.handleError(error);
        }
    }

    async subscribe(user, mediaType) {
        try {
            let self = this;
            const uid = user.uid;
            // subscribe to a remote user
            await this.client.subscribe(user, mediaType);
            console.log("agoraRTC subscribe success for user " + getNameFromUserID(uid));

            updateParticipantConferenceInfo(uid, true);

            if (mediaType === self.mediaType.AUDIO) {
                user.audioTrack.play();

                const speech = hark(self.getMediaStream(uid), self.harkOptions);

                speech.on('speaking', function () {
                    self.addUserInCanvas(uid);
                });

                speech.on('stopped_speaking', function () {
                    self.removeUserFromCanvas(uid);
                });
            }
        } catch (error) {
            this.handleError(error);
        }
    }

    async handleUserPublished(user, mediaType) {
        const id = user.uid;
        this.remoteUsers[id] = user;
        await this.subscribe(user, mediaType);
    }

    handleUserUnpublished(user) {
        const id = user.uid;
        delete this.remoteUsers[id];
    }

    muteThisUserAudio(userId, value) {
        if (this.getMediaStream(userId)) {
            this.getMediaStream(userId).getAudioTracks().forEach(
                stream => stream.enabled = value
            );
        }
    }

    getMediaStream(userId) {
        if (this.remoteUsers[userId] && this.remoteUsers[userId].audioTrack) {
            return this.remoteUsers[userId].audioTrack._source.sourceNode.mediaStream;
        } else {
            return undefined;
        }
    }

    updateMuteStatus(value) {
        if (value) {
            this.mute();
        } else {
            this.unmute();
        }
    }

    addUserInCanvas(userId) {
        this.addUserEvent.detail.userId = userId;
        document.dispatchEvent(this.addUserEvent);
    }

    removeUserFromCanvas(userId) {
        this.removeUserEvent.detail.userId = userId;
        document.dispatchEvent(this.removeUserEvent);
    }

    updateConferenceStatus(value) {
        this.updateConferenceStatusEvent.detail.conferenceStatus = value;
        document.dispatchEvent(this.updateConferenceStatusEvent);
    }

    mute() {
        try {
            if (this.microphoneTrack) {
                this.microphoneTrack.setEnabled(false);
            }
        } catch (error) {
            this.handleError(error);
        }
    }

    unmute() {
        try {
            if (this.microphoneTrack) {
                this.microphoneTrack.setEnabled(true);
            }
        } catch (error) {
            this.handleError(error);
        }
    }

    async onPermissionForConference(value) {
        try {
            this.updateConferenceMenuStatus(value);

            if (value) {
                await this.joinClient(wv.registeredID.toString());
                this.muteMicrophone(value);
            }

            this.updateConferenceStatus(value);
        } catch (error) {
            this.handleError(error);
        }
    }

    updateConferenceMenuStatus(value) {
        wv.effectController.audioConferenceEnabled = value;
        checkBoxSyncVR('webRTCInit', value);
        updateParticipantConferenceInfo(wv.registeredID.toString(), value);
    }
}